import { ItemData } from 'core/models/Template'

export const TEACHERS_CATALOG_TYPE = 'teachers' as const

export const TEACHERS_CATALOG_CONFIG = {
    type: TEACHERS_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
    treeView: false,
} as const

export type TeachersSelectedItems = ItemData[]
